import React from "react";
import { QrCode, ShoppingBag, Check } from "lucide-react";
import { CTA_PRICE } from "../../config/pricing";
import { useLanguage } from "../../contexts/LanguageContext";

const HeroSection = ({ onScanQR, onGetQRCode }) => {
  const { t } = useLanguage();
  const checkItems = [t("hero.check1"), t("hero.check2"), t("hero.check3")];

  return (
    <section className="w-full bg-red-50 px-4 py-8 md:px-6 md:py-10 lg:py-12">
      <div className="mx-auto max-w-4xl text-center">
        {/* Badge with pulsing red dot */}
        <div className="mb-4 flex items-center justify-center gap-2 md:mb-5">
          <span
            className="h-2 w-2 flex-shrink-0 rounded-full bg-red-500 animate-pulse"
            aria-hidden="true"
          />
          <span className="text-sm font-medium text-gray-700 md:text-base">
            {t("hero.trustedBadge")}
          </span>
        </div>

        {/* Main headline */}
        <h1 className="text-3xl font-bold leading-tight text-gray-900 md:text-4xl lg:text-5xl">
          {t("hero.titleAlt")}
        </h1>

        {/* Subtitle */}
        <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-gray-600 md:mt-4 md:text-lg">
          {t("hero.subtitleAlt")}
        </p>

        {/* CTA Buttons */}
        <div className="mt-6 flex flex-col items-center justify-center gap-4 sm:flex-row md:mt-8">
          <button
            type="button"
            onClick={onScanQR}
            className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-red-600 px-6 py-3.5 text-base font-semibold text-white shadow-md transition-colors hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:w-auto"
          >
            <QrCode className="h-5 w-5" aria-hidden="true" />
            {t("hero.scanCta")}
          </button>
          <button
            type="button"
            onClick={onGetQRCode}
            className="inline-flex w-full items-center justify-center gap-2 rounded-lg border-2 border-red-600 bg-white px-6 py-3.5 text-base font-semibold text-red-600 transition-colors hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:w-auto"
          >
            <ShoppingBag className="h-5 w-5" aria-hidden="true" />
            {t("hero.getQRCta")} — {CTA_PRICE}
          </button>
        </div>

        {/* Check marks */}
        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-8 gap-y-4 md:mt-8">
          {checkItems.map((item) => (
            <div
              key={item}
              className="flex items-center gap-2 text-gray-700"
            >
              <span className="flex h-5 w-5 items-center justify-center rounded-full bg-red-100 text-red-600">
                <Check className="h-3 w-3" strokeWidth={3} aria-hidden="true" />
              </span>
              <span className="text-sm font-medium md:text-base">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
